/**
 * Card component type definitions
 */

export enum CardPadding {
  None = 'none',
  Compact = 'compact',
  Default = 'default',
  Spacious = 'spacious',
}

export enum CardElevation {
  Flat = 'flat',
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

export enum CardVariant {
  Default = 'default',
  Clickable = 'clickable',
  Outlined = 'outlined',
}
